<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title class="ion-text-center header-title">{{ 'PHONE.TITLE' | translate }}</ion-title>

      <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
        <ion-button [routerLink]="['/moj-profil', 'osebni-podatki']" replaceUrl class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons>

       <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>

<!-- page content start -->
<ion-content class="ion-no-padding">
  <ion-grid fixed class="ion-no-padding">
  <app-phone-form [bookingDialog]="true"></app-phone-form>
  </ion-grid>
</ion-content>
<!-- page content end -->